import { TeamDetailResponse } from "@/web-client/api";
import { FC, PropsWithChildren } from "react";
import TeamHeader from "@/features/team/components/TeamHeader";

type Props = {
  team: TeamDetailResponse;
};

const TeamGrid: FC<PropsWithChildren<Props>> = ({
  team,
  children,
}): JSX.Element => {
  return (
    <div className="overflow-hidden px-16 py-32 space-y-48 laptop:space-y-0 laptop:grid laptop:gap-32 laptop:py-64 laptop:grid-cols-[minmax(240px,320px)_minmax(0,1fr)] mx-auto laptop:px-48">
      <div className="max-w-[320px] w-full mx-auto laptop:col-start-1 laptop:col-end-2">
        <TeamHeader team={team} />
      </div>
      <div className="laptop:col-start-2 laptop:col-end-3">{children}</div>
    </div>
  );
};

export default TeamGrid;
